var childrenRootLegacy = 'fx_2d2fb1e5_1fza2i10';
var scrollAreaRootLegacy = 'fx_2d2fb1e5_1fza2i11';
var scrollAreaViewportLegacy = 'fx_2d2fb1e5_1fza2i15';
var scrollAreaViewportLegacyPaddingBottom = 'var(--fx_2d2fb1e5_1fza2i14)';
var scrollAreaViewportLegacyPaddingTop = 'var(--fx_2d2fb1e5_1fza2i13)';
var scrollbarMarginTop = 'var(--fx_2d2fb1e5_1fza2i12)';

export { childrenRootLegacy, scrollAreaRootLegacy, scrollAreaViewportLegacy, scrollAreaViewportLegacyPaddingBottom, scrollAreaViewportLegacyPaddingTop, scrollbarMarginTop };
//# sourceMappingURL=scrollAreaLegacy.vanilla.mjs.map
